import * as React from 'react';

const BookmarkChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="bookmark-chunky_svg__eds-icon--bookmark-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bookmark-chunky_svg__eds-icon--bookmark-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 6h8v10.3l-4-2.7-4 2.7V6zM6 4v16l6-4 6 4V4H6z"
        />
    </svg>
);

BookmarkChunkySvg.displayName = 'BookmarkChunkySvg';
export default BookmarkChunkySvg;
